// components/Turnstile.jsx
// Case anti-robot Cloudflare Turnstile. La clé publique (siteKey) vient du serveur ; le secret n'est jamais ici.
// onToken(jeton) est appelé à la réussite, onToken('') si le jeton expire ou si le widget échoue.
// Changer `reinitialiser` (nombre) remet la case à zéro (un jeton ne sert qu'une fois).

import React, { useEffect, useRef } from 'react';

const SCRIPT = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let chargement = null;

function chargerScript() {
  if (window.turnstile) return Promise.resolve();
  if (!chargement) {
    chargement = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = SCRIPT;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { chargement = null; reject(new Error('turnstile')); };
      document.head.appendChild(s);
    });
  }
  return chargement;
}

export default function Turnstile({ siteKey, onToken, reinitialiser = 0 }) {
  const conteneur = useRef(null);
  const idWidget = useRef(null);
  const rappel = useRef(onToken);
  rappel.current = onToken;

  useEffect(() => {
    let annule = false;
    chargerScript().then(() => {
      if (annule || !conteneur.current || !window.turnstile) return;
      // « flexible » = largeur du conteneur (minimum 300 px) ; « compact » (150 px) si le conteneur est plus étroit :
      // le widget reste ainsi toujours dans sa carte, sans défilement horizontal.
      const size = conteneur.current.clientWidth >= 300 ? 'flexible' : 'compact';
      idWidget.current = window.turnstile.render(conteneur.current, {
        sitekey: siteKey,
        size,
        callback: (jeton) => rappel.current(jeton),
        'expired-callback': () => rappel.current(''),
        'error-callback': () => rappel.current(''),
      });
    }).catch(() => rappel.current(''));
    return () => {
      annule = true;
      if (idWidget.current != null && window.turnstile) window.turnstile.remove(idWidget.current);
      idWidget.current = null;
    };
  }, [siteKey]);

  useEffect(() => {
    if (reinitialiser && idWidget.current != null && window.turnstile) window.turnstile.reset(idWidget.current);
  }, [reinitialiser]);

  return <div ref={conteneur} className="turnstile" />;
}
